import { motion } from "framer-motion";
import { SectionHeading, SectionLabel } from "./Section";

const ideas = [
  { title: "AI Productivity SaaS", desc: "Tools that compress hours of work into minutes." },
  { title: "Personalized Learning Platform", desc: "Adaptive education shaped to each learner." },
  { title: "Automation Systems For Businesses", desc: "Quiet engines running the boring work." },
  { title: "Creator AI Tools", desc: "Studio-grade creation in the hands of individuals." },
  { title: "AI Research Assistant", desc: "A second brain for builders and thinkers." },
];

export function FutureProjects() {
  return (
    <section className="relative py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16 flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <SectionLabel>Roadmap</SectionLabel>
            <SectionHeading>Ideas I Want To Build</SectionHeading>
          </div>
          <div className="glass rounded-full px-4 py-2 text-xs text-muted-foreground">
            Future explorations · not shipped
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {ideas.map((idea, i) => (
            <motion.div
              key={idea.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className="group relative flex h-full flex-col justify-between overflow-hidden rounded-2xl border border-white/[0.06] bg-white/[0.02] p-7 transition-all hover:-translate-y-1 hover:border-electric/30"
            >
              <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                <div className="absolute -inset-px bg-[radial-gradient(circle_at_70%_0%,oklch(0.7_0.22_250/0.18),transparent_60%)]" />
              </div>
              <div className="relative">
                <div className="flex items-center justify-between text-xs text-muted-foreground">
                  <span className="font-mono">CONCEPT · 0{i + 1}</span>
                  <span className="rounded-full border border-white/10 px-2 py-0.5 text-[10px] uppercase tracking-widest">
                    Future
                  </span>
                </div>
                <h3 className="mt-6 text-xl font-semibold tracking-tight">{idea.title}</h3>
                <p className="mt-3 text-sm text-muted-foreground">{idea.desc}</p>
              </div>
              <div className="relative mt-8 inline-flex items-center gap-2 text-sm text-electric opacity-70 transition-opacity group-hover:opacity-100">
                In exploration
                <span className="transition-transform group-hover:translate-x-0.5">→</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
